import React, { Fragment ,useEffect,useState,useRef } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Label, Input, FormGroup 
} from "reactstrap";
import "./paymentDetails.scss";
import { useForm } from "react-hook-form";
import RequiredIndicator from "../../../partial/RequiredIndicator";
import { toast } from 'react-toastify';
import { customerPayment } from "../../../../api";
import { Spinner } from 'reactstrap';
import { useSelector , useDispatch} from "react-redux";
import { policy } from "../../../../redux/policy/action";
import { useNavigate , useLocation} from "react-router-dom";
import { SALES_MANAGER, USE_V2_WEBSOCKET } from "../../../../constant";
import usePaymentWebSocket from "../../../../hooks/usePaymentWebSocket";

const CustomerPaymentConfirmModal = (props) => {
  const {
    isOpen,
    toggle,
    handleOfflinePaymentSubmit,
    isMultiTraveller,
    multiTravellerGrandTotal,
    quotationNumber: propQuotationNumber,
  } = props;

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({});
  
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [processing, setProcessing] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [notifications, setNotifications] = useState(null);
  const [reqEmail, setEmail] = useState();
  const [paymentLink, setPaymentLink] = useState("");
  const [txnid, setTxnid] = useState(null);
  const eventSourceRef = useRef(null);
  const policyData = useSelector((content) => content.Policy);
  const quotationNumber = propQuotationNumber || policyData?.travellerDetails?.quotation_number || policyData?.generateQuote?.quotation_number || policyData?.quotation_number || '';
  const PolicyDetails = policyData.generateQuote;
  const location = useLocation();

  const { paymentEvent, clearEvent } = usePaymentWebSocket(txnid, USE_V2_WEBSOCKET && !!txnid);
  console.log(`CustomerPaymentConfirmModal rendered! txnid: ${txnid}, USE_V2_WEBSOCKET: ${USE_V2_WEBSOCKET}`);

  const planCost = isMultiTraveller
    ? (multiTravellerGrandTotal != null ? multiTravellerGrandTotal.toFixed(2) : "0.00")
    : Number(PolicyDetails?.travellers?.[0]?.plan_cost ?? PolicyDetails?.pricing_member_premium ?? PolicyDetails?.plan_cost ?? 0).toFixed(2);
  const displayPlanName = isMultiTraveller ? "Multiple Plans " : PolicyDetails?.travellers[0]?.plan_name;
  
  const ROLE = JSON.parse(localStorage.getItem("ROLE"));
  const role_key = ROLE?.key;
  const role_id = ROLE?.role_id;

  const user =  role_key == SALES_MANAGER ? location?.state?.user : JSON.parse(localStorage.getItem("user"));
  const id = role_key == SALES_MANAGER ? user?.partnerInfo?.partnerInfo?.user?.user_id : user?.user_id  ? user.user_id : '';

  const handlePayment = async (data) => {
    setProcessing(true);
    const formData ={
      reqEmail : data.reqEmail,
      quotation_number: quotationNumber,
      amount: planCost,
      role_id: role_id,
      "yek_ku76H6felco7": "#$x82kc6&m*E"
    }
    try{
      const response = await customerPayment(formData);
      if (response && response.status === 200) {
        toast.success('Quotation has been saved; Document will be generated once payment is done.');
        setPaymentLink(response.data?.result?.URL);
        if (response.data?.result?.txnid) {
          setTxnid(response.data.result.txnid);
        }
        setPageLoading(true);
        setProcessing(false);
      }
    }catch (error) {
      const errorMsg = error?.response?.data?.error || "Failed to process payment.";
      toast.error(errorMsg);
      setProcessing(false);
      setPageLoading(false)
    }
  }

  const handleCloseIcon = () => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }
    setPageLoading(false);
    setTxnid(null);
    clearEvent && clearEvent();
    toggle();
  };

  useEffect(() => {
    if (paymentEvent) {
      const detail = paymentEvent.payload;
      setNotifications({ ...detail, status: 'completed' });
      
      if (detail?.milestone === 'PROCESS_COMPLETE' || detail?.status?.toLowerCase() === 'completed') {
        setTimeout(() => {
          if (detail?.document_unique_code) {
            dispatch(policy({ 
              ...policyData, 
              travellerDetails: { ...policyData.travellerDetails, travelCareMembershipNo: detail.document_unique_code } 
            }));
          }
          handleOfflinePaymentSubmit({ ...detail, status: 'completed' });
          handleCloseIcon();
        }, 1500);
      }
      clearEvent();
    }
  }, [paymentEvent, clearEvent, dispatch, handleOfflinePaymentSubmit, policyData]);

  useEffect(()=>{
    if(pageLoading){
      if(eventSourceRef.current){
        eventSourceRef.current.close()
      }

      const eventSource = new EventSource(`${process.env.REACT_APP_SERVER_URL}/payment-notifications-new/${id}`);
      
      eventSource.onopen = () => {};
    
      eventSource.onmessage = function (event) {
        const newData = JSON.parse(event.data);
        if (newData.type === 'payment') {
          setNotifications(newData);
          const travelCareMembershipNo = newData?.documentId;
          if (travelCareMembershipNo) {
            dispatch(policy({ ...policyData, travellerDetails: { ...policyData.travellerDetails, travelCareMembershipNo: travelCareMembershipNo } }));
          }
          
          if (newData.status?.toLowerCase() === 'completed') {
             setTimeout(() => {
                handleOfflinePaymentSubmit(newData);
                handleCloseIcon();
             }, 1500);
          }
        }
      };
      
      eventSource.onerror = function (error) {
        console.error("SSE connection error:", error);
      };

      eventSourceRef.current = eventSource;
      return () => {
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
          eventSourceRef.current = null;
        }
      };
    }
  },[pageLoading])
  

  useEffect(()=>{
    let timerNotification;
    if(pageLoading && !notifications){
      timerNotification = setTimeout(()=>{
        if (!notifications) {
          toast.error("Payment timeout. No response received.");
          setPageLoading(false);
        }
      }, 5 * 60 * 1000)
    }
    
    if(notifications){
      clearTimeout(timerNotification);
    }

    return () => {
      clearTimeout(timerNotification)
    };
   
  },[notifications, pageLoading])



  const handleFinish = () => {
    if (notifications && notifications.status?.toLowerCase() === "completed") {
      if (notifications.document_unique_code) {
        dispatch(policy({ 
          ...policyData, 
          travellerDetails: { 
            ...policyData.travellerDetails, 
            travelCareMembershipNo: notifications.document_unique_code 
          } 
        }));
      }
      handleOfflinePaymentSubmit(notifications);
    }
    handleCloseIcon();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentLink)
        .then(() => toast.success('Copied Link..!'))
  };

  const renderFormView = () => (
    <div className="view-form">
      <Form className="needs-validation" onSubmit={handleSubmit(handlePayment)}>
        <Row>
          <Col md="12">
            {isMultiTraveller && (
              <div style={{ textAlign: "center", marginBottom: "25px", padding: "15px", background: "#f8f9fa", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
                <p style={{ margin: "0 0 5px 0", fontWeight: "600", fontSize: "15px", color: "#1e293b" }}>{displayPlanName}</p>
                <p style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#3c3cff" }}>₹ {planCost}</p>
                <small style={{ color: "#64748b" }}>Total Amount (incl. GST)</small>
              </div>
            )}
            <FormGroup>
              <div style={{ textAlign: "center" }}>
                <Label style={{fontWeight: 600}}>{"Customer Email"}</Label> <RequiredIndicator />
                <Input
                  type="text"
                  maxLength={50}
                  name="reqEmail"
                  className="form-control digits policy-input-css"
                  placeholder="Enter email address"
                  style={{borderRadius: "10px", padding: "12px 15px", marginTop: "8px"}}
                  innerRef={register({
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email format",
                    }
                  })}
                  onChange={(e)=>{setEmail(e.target.value)}}
                />
                {errors.reqEmail && <p className="text-danger mt-1">{errors.reqEmail.message}</p>}
              </div>
            </FormGroup>
          </Col>
        </Row>
        <div className="d-flex justify-content-between mt-4">
          <Button color="light" className="px-4 rounded-pill stepper-back-btn" disabled={processing} onClick={toggle} style={{fontWeight: 600}}>
            Cancel
          </Button>
          <Button color="primary" type="submit" className="px-5 rounded-pill stepper-next-btn" disabled={processing} style={{fontWeight: 600, boxShadow: "0 4px 10px rgba(60, 60, 255, 0.3)"}}>
            {processing ? "Processing..." : "Generate Link"}
          </Button>
        </div>
      </Form>
    </div>
  );

  const renderProcessingView = () => (
    <div className="view-processing">
      {notifications && notifications.status?.toLowerCase() === 'completed' && notifications.milestone !== 'PROCESS_COMPLETE' ? (
        <>
          <div className="loading-icon">
            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          </div>
          <h4>{notifications.milestone === 'DOCUMENT_GENERATING' ? 'Generating Documents' : 'Payment Verified'}</h4>
          <p style={{ fontSize: '15px', color: '#3c3cff', fontWeight: '500' }}>{notifications.message || 'Processing your request...'}</p>
        </>
      ) : !processing && (!paymentLink || paymentLink === "null" || paymentLink === "{}" || (typeof paymentLink === 'object' && Object.keys(paymentLink).length === 0)) ? (
        <>
          <div className="status-icon-wrapper" style={{color: '#ef4444', fontSize: '32px'}}>⚠️</div>
          <h4 style={{color: '#ef4444'}}>Generation Failed</h4>
          <p>URL generation failed, please regenerate.</p>
          <div className="link-actions">
            <Button color="primary" onClick={() => handlePayment({ reqEmail })}>Retry</Button>
            <Button color="light" onClick={handleCloseIcon}>Cancel</Button>
          </div>
        </>
      ) : (
        <>
          <div className="loading-icon">
            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          </div>
          <h4>Awaiting Payment</h4>
          <p>We've sent a link to <b>{reqEmail}</b>.<br/>You can also copy or open the link directly below.</p>
          
          <div className="link-actions">
            <Button color="primary" outline onClick={() => window.open(paymentLink, '_blank')} className="btn">
              Open Link
            </Button>
            <Button color="primary" onClick={handleCopy} className="btn" style={{boxShadow: "0 4px 10px rgba(60, 60, 255, 0.3)"}}>
              Copy Link
            </Button>
            {/* <Button color="light" onClick={handleCloseIcon} className="btn">
              Close
            </Button> */}
          </div>
        </>
      )}
    </div>
  );

  const renderResultView = () => {
    const isSuccess = notifications.status?.toLowerCase() === "completed";
    let formattedDateTime = "N/A";
    if (notifications.timestamp) {
      const date = new Date(notifications.timestamp);
      if (!isNaN(date.getTime())) {
        formattedDateTime = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
      }
    }

    return (
      <div className="view-result">
        <div className="status-icon-wrapper">
          {isSuccess ? (
            <svg className="svg-success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle cx="26" cy="26" r="25" fill="none" stroke="#10b981" strokeWidth="4" />
              <path className="path" fill="none" stroke="#10b981" strokeWidth="4" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
          ) : (
            <svg className="svg-failed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle cx="26" cy="26" r="25" fill="none" stroke="#ef4444" strokeWidth="4" />
              <path className="path" fill="none" stroke="#ef4444" strokeWidth="4" d="M16 16 36 36 M36 16 16 36" />
            </svg>
          )}
        </div>
        
        <h3 className={`title ${isSuccess ? 'success' : 'failed'}`}>
          {isSuccess ? "Payment Successful! 🎉" : "Payment Failed"}
        </h3>
        
        <div className="details-grid">
          {isSuccess && (
            <div className="detail-row">
              <span className="label">Quotation No.</span>
              <span className="value">{quotationNumber || 'N/A'}</span>
            </div>
          )}
          {isSuccess && notifications.document_unique_code && (
            <div className="detail-row">
              <span className="label">Document Ref.</span>
              <span className="value">{notifications.document_unique_code}</span>
            </div>
          )}
          <div className="detail-row">
            <span className="label">Amount</span>
            <span className="value">₹ {notifications.amount || planCost}</span>
          </div>
          <div className="detail-row">
            <span className="label">Date & Time</span>
            <span className="value">{formattedDateTime}</span>
          </div>
          <div className="detail-row">
            <span className="label">Payment ID</span>
            <span className="value">{notifications.paymentId || 'N/A'}</span>
          </div>
        </div>

        <button className={`btn-finish ${isSuccess ? 'success' : 'failed'} text-white`} onClick={handleFinish}>
          {isSuccess ? "Complete & Continue" : "Close"}
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={handleCloseIcon} backdrop="static" className="payment-modal-unified" centered>
        <ModalHeader toggle={handleCloseIcon}>Confirm Payment</ModalHeader>
        <ModalBody className="unified-modal-body">
          {(notifications && (notifications.milestone === 'PROCESS_COMPLETE' || notifications.status?.toLowerCase() === 'completed' || notifications.status?.toLowerCase() === 'failed')) 
            ? renderResultView() 
            : (pageLoading || (notifications && notifications.milestone !== 'PROCESS_COMPLETE' && notifications.status?.toLowerCase() !== 'completed') ? renderProcessingView() : renderFormView())}
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CustomerPaymentConfirmModal;
